
export const countries = [
    {
        id: 1,
        name: 'Nigeria',
        code: "NG",
        currency: 'N',
        timeZone: "+1",
        countryCode: "+234",
        factor: 50,
        betIdDifference: 0,
        link: 'betway.com.ng',
        flag: 'NG.svg',
        hasHideBalance: false,
        hasCasinoGames: false,
        transactionKeywords: {
            "Withdrawal": "Withdrawal",
            "Payout": "Payout",
            "Win Boost Cash Bonus": "Win Boost Cash Bonus",
            "Card Deposit": "Card Deposit"
        },
        carousels: [
            'BW_ZM_885_177_SuperboostSaturdayMobile.webp',
            'NG_FeaturesLandingPage_Mobile_885x177_SYNAPSE2.webp',
            'BW_NG_885_177_PromoNameMobile.webp',
            '25991_SA_TaxScratch_Limited_Mobile-2.webp',
            '26967_NG_NBAREGULAR_Mobile_Banner_855x177.webp'
        ],
        footers: [
            'footerng.jpg',
            'footerng1.jpg',
            'footerng2.jpg'
        ],
        boostFactors: {
            '0': 0.0,
            '1': 0.0,
            '2': 0.03,
            '3': 0.05,
            '4': 0.09,
            '5': 0.15,
            '6': 0.2,
            '7': 0.25,
            '8': 0.3,
            '9': 0.35,
            '10': 0.4,
            '11': 0.5,
            '12': 0.6,
            '13': 0.65,
            '14': 0.7,
            '15': 0.75,
            '16': 0.8,
            '17': 0.9,
            '18': 1,
            '19': 1.1,
            '20': 1.2,
            '21': 1.4,
            '22': 1.6,
            '23': 1.8,
            '24': 2,
            '25': 2.1,
            '26': 2.2,
            '27': 2.4,
            '28': 2.6,
            '29': 2.8,
            '30': 3,
            '31': 3.2,
            '32': 3.4,
            '33': 3.6,
            '34': 3.8,
            '35': 4,
            '36': 4.25,
            '37': 4.5,
            '38': 5,
            '39': 6,
            '40': 7,
        }
    },
    // {
    //     id: 1,
    //     name: 'UK',
    //     code: "GB",
    //     currency: '£',
    //     timeZone: "+0",
    //     countryCode: "+1",
    //     factor: 0.1,
    //     betIdDifference: 0,
    //     link: 'betway.com/en-gb',
    //     flag: '',
    //     hasHideBalance: false,
    //     hasCasinoGames: false,
    //     transactionKeywords: {
    //         "Withdrawal": "Withdrawal",
    //         "Payout": "Payout",
    //         "Win Boost Cash Bonus": "Win Boost Cash Bonus",
    //         "Card Deposit": "Card Deposit"
    //     },
    //     carousels: [
    //         '25964_SA_ROACasinoInformativeGeneric_Mobile.webp',
    //         'BW_SA_885_177_BetgamesCrashGames_Mobile.webp',
    //         '25991_SA_TaxScratch_Limited_Mobile-2.webp',
    //         'SA_FeaturesLandingPage_Mobile_885x177_SYNAPSE_NEW2.webp'
    //     ],
    //     footers: [
    //         'footerng.jpg',
    //         'footerng1.jpg',
    //         'footerng2.jpg'
    //     ],
    //     boostFactors: {
    //         '0': 0.0,
    //         '1': 0.0,
    //         '2': 0.03,
    //         '3': 0.05,
    //         '4': 0.09,
    //         '5': 0.15,
    //         '6': 0.2,
    //         '7': 0.25,
    //         '8': 0.3,
    //         '9': 0.35,
    //         '10': 0.4,
    //         '11': 0.5,
    //         '12': 0.6,
    //         '13': 0.65,
    //         '14': 0.7,
    //         '15': 0.75,
    //         '16': 0.8,
    //         '17': 0.9,
    //         '18': 1,
    //         '19': 1.1,
    //         '20': 1.2,
    //         '21': 1.4,
    //         '22': 1.6,
    //         '23': 1.8,
    //         '24': 2,
    //         '25': 2.1,
    //         '26': 2.2,
    //         '27': 2.4,
    //         '28': 2.6,
    //         '29': 2.8,
    //         '30': 3,
    //         '31': 3.2,
    //         '32': 3.4,
    //         '33': 3.6,
    //         '34': 3.8,
    //         '35': 4,
    //         '36': 4.25,
    //         '37': 4.5,
    //         '38': 5,
    //         '39': 6,
    //         '40': 7,
    //     }
    // },
    {
        id: 2,
        name: 'South Africa',
        code: "ZA",
        currency: 'R',
        timeZone: "+2",
        factor: 1,
        countryCode: "+27",
        betIdDifference: 1144751000,
        link: 'betway.co.za',
        flag: '',
        hasHideBalance: true,
        hasCasinoGames: true,
        transactionKeywords: {
            "Withdrawal": "EFT Withdrawal",
            "Payout": "Payout",
            "Win Boost Cash Bonus": "Win Boost Cash Bonus",
            "Card Deposit": "OTT Voucher Deposit",
            depositDigitsLength: 12,
            hasBalance: true,
        },
        carousels: [
            'BW_SA_WelcomeOfferFull_Mobile_update_AFC.webp',
            '25964_SA_ROACasinoInformativeGeneric_Mobile.webp',
            'BW_SA_885_177_BetgamesCrashGames_Mobile.webp',
            '25991_SA_TaxScratch_Limited_Mobile-2.webp',
            'SA_FeaturesLandingPage_Mobile_885x177_SYNAPSE_NEW2.webp'
        ],
        footers: [
            'footer.jpg',
            'footer1.jpg',
            'footer2.jpg'
        ],
        boostFactors: {
            '0': 0.0,
            '1': 0.0,
            '2': 0.03,
            '3': 0.05,
            '4': 0.09,
            '5': 0.15,
            '6': 0.2,
            '7': 0.25,
            '8': 0.3,
            '9': 0.35,
            '10': 0.4,
            '11': 0.5,
            '12': 0.6,
            '13': 0.65,
            '14': 0.7,
            '15': 0.75,
            '16': 0.8,
            '17': 0.9,
            '18': 1,
            '19': 1.1,
            '20': 1.2,
            '21': 1.4,
            '22': 1.6,
            '23': 1.8,
            '24': 2,
            '25': 2.1,
            '26': 2.2,
            '27': 2.4,
            '28': 2.6,
            '29': 2.8,
            '30': 3,
            '31': 3.2,
            '32': 3.4,
            '33': 3.6,
            '34': 3.8,
            '35': 4,
            '36': 4.25,
            '37': 4.5,
            '38': 5,
            '39': 6,
            '40': 7,
        }
    },
    // {
    //     id: 3,
    //     name: 'Ghana',
    //     code: "GH",
    //     currency: `GHS`,
    //     timeZone: "+0",
    //     countryCode: "+233",
    //     factor: 1,
    //     betIdDifference: 0,
    //     link: 'betway.com.gh',
    //     flag: 'GH.svg',
    //     hasHideBalance: false,
    //     hasCasinoGames: false,
    //     transactionKeywords: {
    //         "Withdrawal": "Withdrawal",
    //         "Payout": "Payout",
    //         "Win Boost Cash Bonus": "Win Boost Cash Bonus",
    //         "Card Deposit": "Card Deposit"
    //     },
    //     carousels: [
    //         '25964_SA_ROACasinoInformativeGeneric_Mobile.webp',
    //         'BW_SA_885_177_BetgamesCrashGames_Mobile.webp',
    //         '25991_SA_TaxScratch_Limited_Mobile-2.webp',
    //         'SA_FeaturesLandingPage_Mobile_885x177_SYNAPSE_NEW2.webp'
    //     ],
    //     footers: [
    //         'footerng.jpg',
    //         'footerng1.jpg',
    //         'footerng2.jpg'
    //     ],
    //     boostFactors: {
    //         '0': 0.0,
    //         '1': 0.0,
    //         '2': 0.03,
    //         '3': 0.05,
    //         '4': 0.09,
    //         '5': 0.15,
    //         '6': 0.2,
    //         '7': 0.25,
    //         '8': 0.3,
    //         '9': 0.35,
    //         '10': 0.4,
    //         '11': 0.5,
    //         '12': 0.6,
    //         '13': 0.65,
    //         '14': 0.7,
    //         '15': 0.75,
    //         '16': 0.8,
    //         '17': 0.9,
    //         '18': 1,
    //         '19': 1.1,
    //         '20': 1.2,
    //         '21': 1.4,
    //         '22': 1.6,
    //         '23': 1.8,
    //         '24': 2,
    //         '25': 2.1,
    //         '26': 2.2,
    //         '27': 2.4,
    //         '28': 2.6,
    //         '29': 2.8,
    //         '30': 3,
    //         '31': 3.2,
    //         '32': 3.4,
    //         '33': 3.6,
    //         '34': 3.8,
    //         '35': 4,
    //         '36': 4.25,
    //         '37': 4.5,
    //         '38': 5,
    //         '39': 6,
    //         '40': 7,
    //     }
    // },
]